import React, { useState } from "react";
import instance from "../api/api";

function UploadCSV({endpoint}) {
  const [file, setFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      setUploadStatus("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("csvFile", file);

    try {
      const response = await instance.post(endpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setUploadStatus("File uploaded successfully!");
      // Save response data to local storage
      const configData = response.data;
      localStorage.setItem("parameters", JSON.stringify(configData));

    } catch (error) {
      setUploadStatus("File upload failed. Please try again.");
      console.error("Error uploading file:", error);
    }
  };

  return (
    <div className="upload-csv rounded-md w-1/2">
      <input className="rounded-lg" type="file" accept=".csv" onChange={handleFileChange} />
      <button className="border-2 bg-caribbeanCurrent p-2 rounded-xl text-white hover:text-black hover:bg-white border-caribbeanCurrent" onClick={handleUpload}>Upload</button>
      {uploadStatus && <p>{uploadStatus}</p>}
    </div>
  );
}

export default UploadCSV;